export default {
    Metadata: {
        Name: "DateDiffMinute",
        Description: "Returns the difference in minutes between the two dates specified.",
        Syntax: "DateDiffMinute(date, date)",
        Keywords: ['Date'],
        Author: "DataVoke, Inc.",
    },
    execute(startDate, endDate) {
        startDate = app.dv.helpers.exprEng.expr.todate(startDate);
        endDate = app.dv.helpers.exprEng.expr.todate(endDate);
        if (startDate == null || endDate == null) {
            return 0;
        }

        var msDiff = parseInt((endDate - startDate) / 60000),
            tz1 = startDate.getTimezoneOffset(),
            tz2 = endDate.getTimezoneOffset();

        if (tz1 != tz2) {
            msDiff -= (tz2 - tz1);
        }

        return msDiff;
    },
};

